import styled from "styled-components";

export const ContentWithSidebar = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto auto;
  
  ${({ theme }) => theme.breakpoints.tablet} {
    grid-template-columns: 2fr 1fr;
    grid-template-rows: auto;
    column-gap: ${({ theme }) => theme.spacePx("tablet", 7)};
  }

  ${({ theme }) => theme.breakpoints.tabletLandscape} {
    grid-template-columns: 13fr 8fr;
    grid-template-rows: auto;
    column-gap: ${({ theme }) => theme.spacePx("tablet", 6)};
  }

  ${(props) =>
    props.theme.apply(["desktop", "screen"], (breakpoint: string) => {
      return `
      column-gap: ${props.theme.spacePx(breakpoint, 6)};

        `;
    })}
`;

export default ContentWithSidebar;
